import React from "react";

const ColorEditIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16.9999V14.0749C0 13.8082 0.05 13.5541 0.15 13.3124C0.25 13.0707 0.391667 12.8582 0.575 12.6749L8.95 4.2999L7.5 2.8999L8.95 1.4999L10.85 3.3999L13.95 0.299902C14.0333 0.216569 14.1375 0.149902 14.2625 0.0999023C14.3875 0.0499023 14.5167 0.0249023 14.65 0.0249023C14.7833 0.0249023 14.9083 0.0499023 15.025 0.0999023C15.1417 0.149902 15.25 0.216569 15.35 0.299902L17.7 2.6499C17.7833 2.7499 17.85 2.85824 17.9 2.9749C17.95 3.09157 17.975 3.21657 17.975 3.3499C17.975 3.48324 17.95 3.6124 17.9 3.7374C17.85 3.8624 17.7833 3.96657 17.7 4.0499L14.625 7.1249L16.525 9.0749L15.1 10.4999L13.7 9.0499L5.325 17.4249C5.14167 17.6082 4.92917 17.7499 4.6875 17.8499C4.44583 17.9499 4.19167 17.9999 3.925 17.9999H1C0.716667 17.9999 0.479167 17.9041 0.2875 17.7124C0.0958333 17.5207 0 17.2832 0 16.9999ZM2 15.9999H3.95L12.25 7.6499L10.35 5.7499L2 14.0499V15.9999ZM13.175 5.7499L15.575 3.3499L14.65 2.4249L12.25 4.8249L13.175 5.7499Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export default ColorEditIcon;
